export default __webpack_public_path__ + "static/media/search.75cd40f8.svg";